import type { Editor } from 'grapesjs';
import { CrossTabClipboard } from '../services/CrossTabClipboard';

let clipboard: CrossTabClipboard | null = null;

export const crossTabCopyCommand = {
  run(editor: Editor) {
    // Инициализируем сервис clipboard, если он еще не инициализирован
    if (!clipboard) {
      clipboard = new CrossTabClipboard(editor);
    }

    // Получаем выбранные компоненты
    const selected = editor.getSelectedAll();

    if (!selected || !selected.length) {
      return;
    }

    // Сохраняем в localStorage
    clipboard.copy(selected);

    // Также сохраняем в внутреннем буфере GrapesJS для совместимости
    editor.getModel().set('clipboard', selected);
  },
};

export const initializeCrossTabCopy = (editor: Editor) => {
  // Переопределяем внутреннюю команду CopyComponent
  editor.Commands.add('CopyComponent', crossTabCopyCommand);
};
